import { jsx as n } from "react/jsx-runtime";
import e from "react";
import s from "next/script";
import { u as i } from "../../chunks/use-cookie-consent.DZaidJpA.js";
const c = "invoca-script", f = () => {
  const { gpcEnabled: t, ...o } = i();
  return e.useEffect(() => {
    typeof window < "u" && typeof window.Invoca < "u" && (!o["Analytics & Customization"] || t) && window.location.reload();
  }, [o, t]), !t && o["Analytics & Customization"] && /* @__PURE__ */ n(s, { id: c, children: `(function(i,n,v,o,c,a) { i.InvocaTagId = o; var s = n.createElement('script'); s.type = 'text/javascript';
        s.async = true; s.src = ('https:' === n.location.protocol ? 'https://' : 'http://' ) + v;
        var fs = n.getElementsByTagName('script')[0]; fs.parentNode.insertBefore(s, fs);
        })(window, document, 'solutions.invocacdn.com/js/invoca-latest.min.js', '2875/0661140719');` });
};
export {
  c as INVOCA_SCRIPT_ID,
  f as Invoca
};
